import { render, staticRenderFns } from "./ReportDeskGrid.vue?vue&type=template&id=063e9c55&scoped=true"
import script from "./ReportDeskGrid.vue?vue&type=script&lang=js"
export * from "./ReportDeskGrid.vue?vue&type=script&lang=js"
import style0 from "./ReportDeskGrid.vue?vue&type=style&index=0&id=063e9c55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e9c55",
  null
  
)

export default component.exports